<script lang="ts">
  import Page from '$components/page/Page.svelte';
  import Button from '$components/button/Button.svelte';
  import { getMetriAddress } from '$utils/getMetriAddress';
  import { NEW_DOMAIN } from '$lib/constants/domainMigration';
  import Image from '$lib/assets/passkey-migration-app.webp';
  import { connectWalletAndStoreData } from '$utils/connectWalletAndStoreData';
  import IconShareUpRight from '$lib/icons/IconShareUpRight.svelte';
  import { closeModal, openModal } from '$components/bottom-sheet/index.svelte';
  import FollowOnScreenPrompts from '$modals/follow-on-screen-prompts/FollowOnScreenPrompts.svelte';
  import { runningAsStandalone } from '$utils/runningAsStandalone';

  let address = $state(getMetriAddress());

  const migrate = (): void => {
    if (runningAsStandalone()) {
      window.open(
        `https://${NEW_DOMAIN}/migrate-domain?source=${encodeURIComponent(window.location.origin)}&address=${getMetriAddress()}`,
        '_blank',
      );
      return;
    }
    window.location.href = `https://${NEW_DOMAIN}/migrate-domain?source=${encodeURIComponent(window.location.origin)}&address=${getMetriAddress()}`;
  };

  const login = async () => {
    openModal(FollowOnScreenPrompts);
    try {
      await connectWalletAndStoreData('/migrate-domain');
      if (!getMetriAddress()) {
        return closeModal();
      }
      address = getMetriAddress();
    } catch (_) {
      void closeModal();
    }
  };

  const goToGnosis = async () => {
    if (runningAsStandalone()) {
      window.open(`https://${NEW_DOMAIN}`, '_blank');
      return;
    }
    window.location.href = `https://${NEW_DOMAIN}`;
  };
</script>

<Page>
  {#snippet middle()}
    <div class="p-gno-page pt-16">
      <div class="grid gap-4 text-center">
        <h1 class="typography-h2-bold">A new era for Gnosis</h1>
        <span class="typography-body-l-medium text-foreground-muted">
          We created a new app with a renewed vision. Your assets stay safe. Metri has been
          sunsetted on 26th Feb 2026. Migrate to Gnosis today to keep access to your account.
        </span>
      </div>
      <div class="bg-background-subtle rounded-2xl w-full mt-8 overflow-hidden max-h-80 h-80">
        <img src={Image} class="object-contain mx-auto h-full w-full" alt="Metri is now Gnosis" />
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="p-gno-page grid gap-3">
      {#if address}
        <Button ariaLabel="Start Migration" variant="primary" onclick={migrate}>
          Continue to Gnosis
        </Button>
      {:else}
        <Button ariaLabel="Start Migration" variant="primary" onclick={login}>
          Migrate exising account <IconShareUpRight />
        </Button>
        <Button ariaLabel="Start Migration" variant="tertiary" onclick={goToGnosis}>
          Create new account
        </Button>
      {/if}
    </div>
  {/snippet}
</Page>
